<template>
  <div class="top-menu">
    <v-btn v-for="item in visibleMenuItems" :key="item.tab" class="top-menu-item" variant="text" stacked
      :active="false" @click="openSidebar(item.tab)">
      <span class="top-menu-name">{{ item.label }}</span>
      <template #prepend>
        <div class="top-menu-icon">
          <img :src="item.icon" width="35" height="35" alt="">
        </div>
      </template>
    </v-btn>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from "vue"
import { storeToRefs } from "pinia"
import useUserStore from "@/store/modules/user"
import { canShowPageTopQuickItem } from "@/utils/permission"
import imgClmb from "@/assets/images/home/qj_icon_clmb.png"
import imgDjlr from "@/assets/images/home/qj_icon_djlr.png"
import imgCbjs from "@/assets/images/home/qj_icon_cbjs.png"
import imgYckz from "@/assets/images/home/qj_icon_yckz.png"
import imgSjfx from "@/assets/images/home/qj_icon_sjfx.png"
import imgDbsj from "@/assets/images/home/qj_icon_dbsj.png"

/** tab 与 StationSwitchDialog、电站详情 Tab 文案保持一致；权限见 config/pageTopQuickMenuPerms.js */
const PAGE_TOP_MENU_ITEMS: { tab: string; label: string; icon: string }[] = [
  { tab: "收益总览", label: "收益总览", icon: imgClmb },
  { tab: "电价录入", label: "电价录入", icon: imgDjlr },
  { tab: "主监控", label: "主监控", icon: imgCbjs },
  { tab: "电站拓扑", label: "电站拓扑", icon: imgClmb },
  { tab: "储能系统", label: "储能系统", icon: imgDjlr },
  { tab: "充放记录", label: "充放记录", icon: imgDjlr },
  { tab: "电表数据", label: "电表数据", icon: imgDbsj },
  { tab: "告警管理", label: "告警管理", icon: imgDjlr },
  { tab: "告警信息", label: "告警信息", icon: imgDjlr },
  { tab: "抄表结算", label: "抄表结算", icon: imgCbjs },
  { tab: "策略控制", label: "策略控制", icon: imgYckz },
  { tab: "数据分析", label: "数据分析", icon: imgSjfx },
]

const props = defineProps({
  menus: {
    type: Array,
    default: () => [],
  },
})

const userStore = useUserStore()
const { permissions } = storeToRefs(userStore)

/** 按父组件 :menus 的顺序渲染，仅展示「在 menus 中且具备对应 permission」的项 */
const visibleMenuItems = computed(() => {
  void permissions.value
  const menus = (props.menus as string[]) || []
  const out: { tab: string; label: string; icon: string }[] = []
  for (const tab of menus) {
    const def = PAGE_TOP_MENU_ITEMS.find((it) => it.tab === tab)
    if (def && canShowPageTopQuickItem(tab, menus)) out.push(def)
  }
  return out
})

const openStationSwitch = inject("openStationSwitch", () => { })
const openSidebar = (tab?: string) => {
  openStationSwitch(tab)
}
</script>
<style scoped lang="scss">
.top-menu {
  align-self: end;
  display: flex;
  gap: 8px;

  .top-menu-item {
    cursor: pointer;
    width: 80px;
    // height: 80px;
  }

  .top-menu-icon {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    background: #fff;

    &:hover {
      opacity: 0.8;
    }

    >img {
      width: 30px;
      height: 30px;
    }
  }

  .top-menu-name {
    color: #2E2E2E;
    font-size: 14px;
    font-weight: 300;
    margin-top: 8px;
    white-space: nowrap;
  }

  :deep(.v-btn__overlay) {
    display: none !important;
  }
}
</style>
